import React from "react";

const PasswordRequirement = (props) => {
  return (
    <div style={props.style}>
      Password must contain at least one upper case letter, one lower case
      letter, one number, and one special character.
    </div>
  );
};

export default PasswordRequirement;
